import React, { useEffect, useState } from "react";
import axiosInstance from "../api/axiosInterceptor";
import "../styles/ScheduledClasses.css";
import SyncLoader from "../components/Loader";

const ScheduledClasses = () => {
  const [classes, setClasses] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [isLoading, setIsLoading] = useState(false); // State to control loading
  const [currentPage, setCurrentPage] = useState(1);
const rowsPerPage = 8;

const indexOfLastRow = currentPage * rowsPerPage;
const indexOfFirstRow = indexOfLastRow - rowsPerPage;
const currentRows = classes.slice(indexOfFirstRow, indexOfLastRow);

const totalPages = Math.ceil(classes.length / rowsPerPage);

const handlePageChange = (page) => {
  setCurrentPage(page);
};

  useEffect(() => {
    fetchClasses();
  }, []);

  const fetchClasses = async () => {
    setIsLoading(true);
    try {
      const res = await axiosInstance.get("user/calendar/");
      setClasses(res.data);
    } catch (err) {
      console.error("Error fetching classes:", err);
    }
    finally {
      setIsLoading(false); // Stop the loader
    }
  };

  const startEdit = (cls) => {
    setEditingId(cls.id);
    setEditForm({ ...cls });
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const saveEdit = async () => {
    try {
      await axiosInstance.put(`admin/calendar/${editingId}/`, editForm);
      setEditingId(null);
      fetchClasses();
    } catch (err) {
      console.error("Error updating class:", err);
    }
  };

  const handleDelete = async (clsID) => {
    setIsLoading(true);
    try{
      await axiosInstance.delete(`admin/calendar/?id=${parseInt(clsID)}`);

      const res = await axiosInstance.get("user/calendar/");
      setClasses(res.data);
    } catch (err){
      console.error("Delete Failed:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && <SyncLoader />}
    <div className="scheduled-classes">
  <h2>Scheduled Classes</h2>
  <div className="table-wrapper">
    <table>
      <thead>
        <tr>
          <th>Title</th>
          <th>Description</th>
          <th>Start</th>
          <th>End</th>
          <th>Meeting URL</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
  {currentRows.map((cls) => (
    <tr key={cls.id}>
      {editingId === cls.id ? (
        <>
          <td><input name="title" value={editForm.title} onChange={handleEditChange} /></td>
          <td><input name="description" value={editForm.description} onChange={handleEditChange} /></td>
          <td><input name="start_time" type="datetime-local" value={editForm.start_time} onChange={handleEditChange} /></td>
          <td><input name="end_time" type="datetime-local" value={editForm.end_time} onChange={handleEditChange} /></td>
          <td><input name="meeting_url" value={editForm.meeting_url} onChange={handleEditChange} /></td>
        </>
      ) : (
        <>
          <td>{cls.title}</td>
          <td>{cls.description}</td>
          <td>{cls.start_time}</td>
          <td>{cls.end_time}</td>
          <td>{cls.meeting_url}</td>
          <td><button onClick={() => handleDelete(cls.id)}>Delete</button></td>
        </>
      )}
    </tr>
  ))}
</tbody>
    </table>
  </div>
</div>

<div className="pagination">
  <button
    disabled={currentPage === 1}
    onClick={() => handlePageChange(currentPage - 1)}
  >
    Prev
  </button>

  {[...Array(totalPages)].map((_, idx) => (
    <button
      key={idx}
      className={currentPage === idx + 1 ? "active" : ""}
      onClick={() => handlePageChange(idx + 1)}
    >
      {idx + 1}
    </button>
  ))}

  <button
    disabled={currentPage === totalPages}
    onClick={() => handlePageChange(currentPage + 1)}
  >
    Next
  </button>
</div>

    </>
  );
};

export default ScheduledClasses;
